import useSettingsStore from "@/store/SettingsStore"
import MusicWidget from "../widgets/MusicWidget"
import NotesWidget from "../widgets/NotesWidget"
import { useEffect } from "react";
import QuoteWidget from "../widgets/QuoteWidget";

function WidgetPanel() {

  const toggleWidgetPanel = useSettingsStore(state => state.toggleWidgetPanel)
  const widgetPanel = useSettingsStore(state => state.widgetPanel)
  const widgets = useSettingsStore(state => state.widgets)

  const isSmallScreen = window.matchMedia("(max-width: 1024px)").matches

  useEffect(() => {
    document.addEventListener("keydown", (e) => {
      if (e.key === "w" && e.ctrlKey && e.altKey) {
        toggleWidgetPanel()
      }
    })

    return () => {
      document.removeEventListener("keydown", (e) => {
        if (e.key === "w" && e.ctrlKey && e.altKey) {
          toggleWidgetPanel()
        }
      })
    }
  }, [toggleWidgetPanel]);

  useEffect(() => {
    if (isSmallScreen && widgetPanel) {
      toggleWidgetPanel()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSmallScreen, toggleWidgetPanel])

  return (
    <div
      className={`bg-zinc-900/70 backdrop-blur-md lg:bg-transparent lg:backdrop-blur-0 overflow-y-auto flex flex-col p-3 space-y-2 scroll2 fixed ${widgetPanel ? "right-0" : "-right-full"} transition-all duration-300 top-0 md:max-w-[26rem] w-full h-screen`}
    >
      {widgets.includes("Music") && <MusicWidget />}
      {widgets.includes("Quotes") && <QuoteWidget />}
      {widgets.includes("Notes") && <NotesWidget />}
    </div>
  )
}

export default WidgetPanel